import { render, staticRenderFns } from "./PoqConnectPage.vue?vue&type=template&id=4f841c18&"
import script from "./PoqConnectPage.vue?vue&type=script&lang=ts&"
export * from "./PoqConnectPage.vue?vue&type=script&lang=ts&"
import style0 from "./PoqConnectPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports